require('./cmTransferOriginContractsSummary.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const classnames = require('classnames');

// @commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { ContentBox } = require('commonsComponents/contentBox');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKLink } = require('commonsComponents/OKLink');
const { HYPHEN } = require('constants/index');

// @components
//const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatValue } = require('wealth-cm/utilities/formatValueHelper');
const { getLastNChars } = require('utilities/stringHelper');

// @constants
const { CM_TRANSFER_TAX_EXEMPT_TRUE } = require('../../constants/constants');

class CmTransferOriginContractsSummaryTable extends React.Component {
    constructor(props) {
        super(props);
        this.handleOriginFundSelected = this.handleOriginFundSelected.bind(
            this,
        );
    }

    handleOriginFundSelected(fund, missingTransferFundAmount) {
        this.props.setOriginFund(fund);
        this.props.saveOriginFundInfo(fund, missingTransferFundAmount);
    }

    buildTableHeader() {
        return (
            <OKTableRow
                asHeader={true}
                className="cm-transfer-origin-contracts-summary__header-row hidden-xs"
            >
                <OKTableCell asHeader={true} className=""></OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="cm-transfer-origin-contracts-summary__header-cell"
                >
                    <FormattedText
                        value="brokerCM-transferOriginContractsSummaryFundNameHeader"
                        format="uppercase"
                        className="cm-transfer-origin-contracts-summary__header-content"
                    />
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="cm-transfer-origin-contracts-summary__header-cell"
                >
                    <FormattedText
                        value="brokerCM-transferOriginContractsSummaryIsinHeader"
                        format="uppercase"
                        className="cm-transfer-origin-contracts-summary__header-content"
                    />
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="cm-transfer-origin-contracts-summary__header-cell"
                >
                    <FormattedText
                        value="brokerCM-transferOriginContractsSummaryContractNumberHeader"
                        format="uppercase"
                        className="cm-transfer-origin-contracts-summary__header-document-content"
                    />
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="cm-transfer-origin-contracts-summary__header-cell"
                >
                    <FormattedText
                        value="brokerCM-transferOriginContractsSummaryRentabilityHeader"
                        format="uppercase"
                        className="cm-transfer-origin-contracts-summary__header-content"
                    />
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="cm-transfer-origin-contracts-summary__header-cell"
                >
                    <FormattedText
                        value="brokerCM-transferOriginContractsSummaryActualValueHeader"
                        format="uppercase"
                        className="cm-transfer-origin-contracts-summary__header-content"
                    />
                </OKTableCell>
            </OKTableRow>
        );
    }

    getCellValue(
        canBeTransfered,
        isTraspasable,
        isAsociatedAccountBlocked,
        value,
    ) {
        if (canBeTransfered) {
            if (isAsociatedAccountBlocked) {
                return (
                    <OKTooltip
                        target={value}
                        content="brokerCM-brokerCM_fundWithAsociatedAccountBlocked"
                    />
                );
            } else {
                return value;
            }
        } else if (!isTraspasable) {
            return (
                <OKTooltip
                    target={value}
                    content="brokerCM-transferOriginContractsSummaryNonTraspasable"
                />
            );
        } else {
            const tooltipText = (
                <div>
                    <div>
                        <FormattedText value="brokerCM-brokerCM_matchesCmPortfolioMinorValueTooltipText" />
                    </div>
                    <div>
                        <FormattedText value="brokerCM-brokerCM_matchesCmPortfolioMinorValueTooltipText2" />
                    </div>
                </div>
            );
            return <OKTooltip target={value} content={tooltipText} />;
        }
    }

    buildRentabilityTooltipContent(rentability, actualValue, totalValue) {
        const tooltipTitle = (
            <FormattedText value="brokerCM-brokerCM_contractsSummaryTooltipTitle" />
        );
        const rentabilityLabel = (
            <FormattedText value="brokerCM-brokerCM_contractsSummaryRentability" />
        );
        const actualValueLabel = (
            <FormattedText value="brokerCM-brokerCM_contractsSummaryActualValue" />
        );
        const totalValueLabel = (
            <FormattedText value="brokerCM-brokerCM_contractsSummaryOperationsValueWithRentability" />
        );
        return (
            <div className="cm-transfer-origin-contracts-summary__tooltip">
                <div className="cm-transfer-origin-contracts-summary__tooltip-title">
                    {tooltipTitle}
                </div>
                <div className="cm-transfer-origin-contracts-summary__tooltip-content">
                    <div className="cm-transfer-origin-contracts-summary__tooltip-value">
                        {HYPHEN}
                    </div>
                    <div className="cm-transfer-origin-contracts-summary__tooltip-label">
                        {rentabilityLabel}
                    </div>
                </div>
                <div className="cm-transfer-origin-contracts-summary__tooltip-content">
                    <div className="cm-transfer-origin-contracts-summary__tooltip-value">
                        {actualValue}
                    </div>
                    <div className="cm-transfer-origin-contracts-summary__tooltip-label">
                        {actualValueLabel}
                    </div>
                </div>
                <div className="cm-transfer-origin-contracts-summary__tooltip-content">
                    <div className="cm-transfer-origin-contracts-summary__tooltip-value">
                        {rentability}
                    </div>
                    <div className="cm-transfer-origin-contracts-summary__tooltip-label">
                        {rentabilityLabel}
                    </div>
                </div>
                <div className="cm-transfer-origin-contracts-summary__tooltip-content">
                    <div className="cm-transfer-origin-contracts-summary__tooltip-value">
                        {totalValue}
                    </div>
                    <div className="cm-transfer-origin-contracts-summary__tooltip-label">
                        {totalValueLabel}
                    </div>
                </div>
            </div>
        );
    }

    getRentabilityTooltip(content) {
        return (
            <OKTooltip
                type="custom"
                modifier="dark-bg"
                iconClass="cm-funds-summary__custom-icon"
                offset={[0, -5]}
                content={content}
            />
        );
    }

    buildTableBody() {
        const {
            selectionFundsInfo,
            originFund,
            totalAmount,
            initialFundId,
            portfolio,
            immAccounts,
        } = this.props;

        return selectionFundsInfo.map(asset => {
            const subAsset = asset.getIn([
                'infoFondosOutput',
                'infoFondosPosicionGlobal',
            ]);
            const transferTaxExempt = asset.getIn([
                'infoFondosOutput',
                'transferTaxExempt',
            ]);
            const isTraspasable =
                transferTaxExempt === CM_TRANSFER_TAX_EXEMPT_TRUE;
            const asociatedAccount = immAccounts
                .get('byId')
                .find(
                    account =>
                        account.get('contractNumber') ===
                        subAsset.getIn(['cuentaAsociada', 'numeroContrato']),
                );
            const isAsociatedAccountBlocked = immAccounts
                .get('blockedAccountsIds')
                .contains(asociatedAccount.get('accountId'));
            let canBeTransfered = isTraspasable;
            const matchesPortfolio = asset.getIn([
                'infoFondosOutput',
                'portfolioFundExisting',
            ]);
            const isin = subAsset.getIn(['instrumentInfo', 'instrumentId']);
            let portfolioImport;
            let portfolioIsin;

            if (matchesPortfolio) {
                portfolio.get('assetClassInfo').forEach(assetClass => {
                    assetClass
                        .get('subAssetClassInfo')
                        .forEach(subAssetClassInfo => {
                            subAssetClassInfo
                                .get('subAssetClassIsinInfo')
                                .find(subAssetClassIsin => {
                                    if (
                                        subAssetClassIsin.get(
                                            'subAssetClassIsin',
                                        ) === isin
                                    ) {
                                        portfolioImport = subAssetClassIsin.get(
                                            'subAssetClassFundAmount',
                                        );
                                        portfolioIsin = isin;
                                    }
                                });
                        });
                });
            }

            const name = subAsset.get('nombre');
            const contractNumber = subAsset.getIn([
                'contrato',
                'numeroContrato',
            ]);
            const rentability = subAsset.getIn([
                'importes',
                'consolidado',
                'rentabilidad',
                'importeEur',
            ]);
            let rentabilityFormatted = rentability
                ? formatValue(
                      rentability.get('importe'),
                      rentability.get('moneda'),
                  )
                : formatText('broker-notAvailableData');
            const notConsolidated = subAsset.getIn(['importes', 'intradia']);
            const actualValue = subAsset.getIn([
                'importes',
                'consolidado',
                'valor',
                'importeEur',
            ]);
            let formatActualValue = actualValue
                ? formatValue(
                      actualValue.get('importe'),
                      actualValue.get('moneda'),
                  )
                : formatText('broker-notAvailableData');
            let defaultCheck = false;
            const totalValue = subAsset.getIn([
                'importes',
                'total',
                'valor',
                'importeEur',
            ]);
            let fundInCmPortfolioText;
            const formatTotalValue = totalValue
                ? formatValue(
                      totalValue.get('importe'),
                      totalValue.get('moneda'),
                  )
                : formatText('broker-notAvailableData');
            let infoIcon;
            let tooltipContent;

            if (
                portfolioImport &&
                totalValue.get('importe') > portfolioImport &&
                originFund === contractNumber
            ) {
                this.props.saveOriginFundMatchedInPortfolio(
                    originFund,
                    portfolioIsin,
                );
                fundInCmPortfolioText = (
                    <OKTableRow>
                        <OKTableCell
                            className="cm-transfer-origin-contracts-summary__matches-cm-portfolio-text"
                            colSpan="6"
                        >
                            <FormattedText value="brokerCM-brokerCM_buyStep1MatchesCmPortfolioMayorValueText1" />
                            <FormattedText value="brokerCM-brokerCM_buyStep1MatchesCmPortfolioMayorValueText2" />
                        </OKTableCell>
                    </OKTableRow>
                );
            } else if (
                portfolioImport &&
                totalValue.get('importe') <= portfolioImport
            ) {
                canBeTransfered = false;
            } else if (originFund === contractNumber) {
                this.props.saveOriginFundMatchedInPortfolio(null);
            }

            const tableBodyClassName = classnames(
                'cm-transfer-origin-contracts-summary__body-cell ',
                {
                    'cm-transfer-origin-contracts-summary__body-cell--disabled ':
                        !canBeTransfered || isAsociatedAccountBlocked,
                },
            );

            if (!!notConsolidated) {
                if (canBeTransfered) {
                    tooltipContent = this.buildRentabilityTooltipContent(
                        rentabilityFormatted,
                        formatTotalValue,
                        formatActualValue,
                    );
                    infoIcon = this.getRentabilityTooltip(tooltipContent);
                }
                formatActualValue = formatTotalValue;
                rentabilityFormatted = HYPHEN;
            }

            if (initialFundId) {
                defaultCheck = true;
            }

            let handleFundOriginClick;
            if (canBeTransfered) {
                handleFundOriginClick = () =>
                    this.handleOriginFundSelected(
                        contractNumber,
                        totalAmount - totalValue.get('importe'),
                    );
            } else if (contractNumber === originFund) {
                this.props.resetOriginFund();
            }

            const fundRow = (
                <React.Fragment>
                    <OKTableRow
                        key={contractNumber}
                        className="cm-transfer-origin-contracts-summary__body-row"
                    >
                        <OKTableCell className={tableBodyClassName}>
                            <span
                                className="radio-button cm-transfer-origin-contracts-summary__cell-content"
                                onClick={handleFundOriginClick}
                            >
                                <input
                                    type="radio"
                                    name="fund"
                                    className="radio-button__input"
                                    disabled={!canBeTransfered}
                                    checked={
                                        contractNumber === originFund ||
                                        defaultCheck
                                    }
                                    value={contractNumber}
                                    onChange={this.handleOriginFundSelected}
                                />
                                <label
                                    className={
                                        canBeTransfered
                                            ? 'radio-button__label cm-transfer-origin-contracts-summary__cell-content-radio'
                                            : 'radio-button__label--disabled cm-transfer-origin-contracts-summary__cell-content-radio'
                                    }
                                    htmlFor={contractNumber}
                                ></label>
                            </span>
                        </OKTableCell>
                        <OKTableCell className={tableBodyClassName}>
                            {this.getCellValue(
                                canBeTransfered,
                                isTraspasable,
                                isAsociatedAccountBlocked,
                                <span className="cm-transfer-origin-contracts-summary__cell-content-first">
                                    {name}
                                </span>,
                            )}
                        </OKTableCell>
                        <OKTableCell className={tableBodyClassName}>
                            {this.getCellValue(
                                canBeTransfered,
                                isTraspasable,
                                isAsociatedAccountBlocked,
                                <span className="cm-transfer-origin-contracts-summary__cell-content-second">
                                    {isin}
                                </span>,
                            )}
                        </OKTableCell>
                        <OKTableCell className={tableBodyClassName}>
                            {this.getCellValue(
                                canBeTransfered,
                                isTraspasable,
                                isAsociatedAccountBlocked,
                                <span className="cm-transfer-origin-contracts-summary__cell-content-third">
                                    {getLastNChars(contractNumber)}
                                </span>,
                            )}
                        </OKTableCell>
                        <OKTableCell className={tableBodyClassName}>
                            {this.getCellValue(
                                canBeTransfered,
                                isTraspasable,
                                isAsociatedAccountBlocked,
                                <span className="cm-transfer-origin-contracts-summary__cell-content-fourth">
                                    {rentabilityFormatted}
                                    {infoIcon}
                                </span>,
                            )}
                        </OKTableCell>
                        <OKTableCell className={tableBodyClassName}>
                            {this.getCellValue(
                                canBeTransfered,
                                isTraspasable,
                                isAsociatedAccountBlocked,
                                <span className="cm-transfer-origin-contracts-summary__cell-content-last">
                                    {formatActualValue}
                                </span>,
                            )}
                        </OKTableCell>
                    </OKTableRow>
                    {fundInCmPortfolioText}
                </React.Fragment>
            );

            return fundRow;
        });
    }

    render() {
        const { selectionFundsInfoEmpty, filteredFundsInfoEmpty } = this.props;
        const summaryClass = classnames({
            'cm-transfer-origin-contracts-summary': !selectionFundsInfoEmpty,
            'cm-transfer-origin-contracts-summary__empty-state': selectionFundsInfoEmpty,
            'cm-transfer-origin-contracts-summary__filter-empty-state': filteredFundsInfoEmpty,
        });

        let content;

        if (!selectionFundsInfoEmpty && !filteredFundsInfoEmpty) {
            content = (
                <OKTable>
                    <thead>{this.buildTableHeader()}</thead>
                    <tbody>{this.buildTableBody()}</tbody>
                </OKTable>
            );
        } else if (selectionFundsInfoEmpty) {
            const link = (
                <OKLink
                    onClick={this.props.handleOnClick}
                    modifier="emphasize"
                    target="_blank"
                    extraClass="cm-transfer-origin-contracts-summary__empty-state-text"
                >
                    <FormattedText value="brokerCM-brokerCM_step1LinkEmptyState" />
                </OKLink>
            );
            const primaryTextWithComponents = (
                <div className="cm-transfer-origin-contracts-summary__empty-state-text">
                    <div>
                        {formatText(
                            'brokerCM-brokerCM_step1PrimaryTextEmptyState',
                        )}
                    </div>
                    <FormattedTextWithComponents
                        value="brokerCM-brokerCM_step1SecondaryTextEmptyState"
                        injectedComponents={[link]}
                    />
                </div>
            );
            content = (
                <EmptyState
                    secondaryText={primaryTextWithComponents}
                    iconType="noitems-wealth"
                    withMargin={false}
                />
            );
        } else if (filteredFundsInfoEmpty) {
            const primaryText = (
                <div className="cm-transfer-origin-contracts-summary__empty-state-text">
                    <div>
                        <FormattedText value="brokerCM-brokerCM_filtersEmptyStateText1" />
                    </div>
                    <div>
                        <FormattedText value="brokerCM-brokerCM_filtersEmptyStateText2" />
                    </div>
                </div>
            );
            content = (
                <div>
                    <OKTable className="cm-transfer-origin-contracts-summary__empty-state-header">
                        <thead>{this.buildTableHeader()}</thead>
                    </OKTable>
                    <EmptyState
                        secondaryText={primaryText}
                        iconType="noitems-wealth"
                        withMargin={false}
                    />
                </div>
            );
        }

        return (
            <ContentBox hasShadow={false} customClassName={summaryClass}>
                {content}
            </ContentBox>
        );
    }
}

CmTransferOriginContractsSummaryTable.propTypes = {
    selectionFundsInfo: PropTypes.object.isRequired,
    selectionFundsInfoEmpty: PropTypes.bool,
    filteredFundsInfoEmpty: PropTypes.bool,
    setOriginFund: PropTypes.func,
    originFund: PropTypes.string,
    totalAmount: PropTypes.number.isRequired,
    handleOnClick: PropTypes.func,
    saveOriginFundInfo: PropTypes.func,
    initialFundId: PropTypes.string,
    portfolio: PropTypes.object,
    resetOriginFund: PropTypes.func,
    saveOriginFundMatchedInPortfolio: PropTypes.func,
    immAccounts: PropTypes.object,
};

module.exports = CmTransferOriginContractsSummaryTable;
